import React from "react";
import AppSelectFormik from "src/commun/composants/formulaire/formik/fields/AppSelectFormik";
import useTitreOptions from "src/commun/hooks/useTitreOptions";
import { useFormikContext } from "formik";

export type TitreFieldProps = {
  defaultValue: string;
  disabled?: boolean;
};

const TitreField = ({ defaultValue, disabled }: TitreFieldProps) => {
  const { submitCount } = useFormikContext();
  const titreOptions = useTitreOptions();

  return (
    <AppSelectFormik
      options={titreOptions}
      name={"title"}
      formulaireSoumis={submitCount > 0}
      defaultValue={defaultValue}
      disabled={disabled}
    />
  );
};

export default TitreField;
